/* ==========================================================================
   Notre Histoire · « le temps qui passe » (Shopify : assets/obaia-section-histoire.js)
   Annotations Figma 927:9866 à 927:9984 (Moha, 30/10).
   Règle de la réunion du 29/10 : rien n’attend. Textes et photos sont lisibles dès qu’ils sont
   à l’écran ; seuls le décor (fil, points, dessins), la couleur des photos de la frise et les
   compteurs réagissent. Sans bibliothèque (ne dépend pas de GSAP).
   « Réduire les animations » et éditeur Shopify : rien ne bouge, la page est celle de la maquette.
   ========================================================================== */
(function () {
  'use strict';
  var O = window.OBAIA;
  if (!O || window.__obaiaHistoire) return;   // le script est appelé par plusieurs sections : une seule fois
  window.__obaiaHistoire = 1;

  var html = document.documentElement;
  function calme() {
    return O.reduce || html.classList.contains('design-mode') || !('IntersectionObserver' in window);
  }

  /* Une seule fois, quand l’élément entre à l’écran (10 % au-dessus du bas) */
  function aLecran(el, fn) {
    var io = new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) { io.disconnect(); fn(); }
    }, { rootMargin: '0px 0px -10% 0px' });
    io.observe(el);
  }

  /* 01 · Ouverture : la photo « respire » (1,05 → 1, 2,4 s) et le trait de signature se dessine */
  function ouverture(root) {
    O.$$('.hi-ouv', root).forEach(function (sec) {
      if (sec._ok) return; sec._ok = 1;
      var img = O.$('.hi-ouv__photo img', sec);
      function go() { sec.classList.add('is-anime'); }
      if (!img || img.complete) go(); else { img.addEventListener('load', go, { once: true }); img.addEventListener('error', go, { once: true }); }
    });
  }

  /* 02 · Citation et 05 · Valeurs : les dessins au trait se tracent à l’entrée à l’écran */
  function traces(root) {
    O.$$('[data-trace]', root).forEach(function (el) {
      if (el._ok) return; el._ok = 1;
      el.classList.add('is-attente');
      aLecran(el, function () { el.classList.add('is-trace'); });
    });
  }

  /* 04 · Chiffres : compteur 0 → chiffre, 1,2 s, ralenti à la fin (le vrai chiffre est dans .visually-hidden) */
  function compteurs(root) {
    O.$$('[data-compteur]', root).forEach(function (el) {
      if (el._ok) return; el._ok = 1;
      var texte = el.textContent, fin = parseInt(texte, 10);
      if (isNaN(fin) || fin < 2) return;
      el.textContent = '0';
      aLecran(el, function () {
        var t0 = null;
        function pas(t) {
          if (t0 === null) t0 = t;
          var k = Math.min(1, (t - t0) / 1200);
          el.textContent = Math.round(fin * (1 - Math.pow(1 - k, 3)));
          if (k < 1) requestAnimationFrame(pas); else el.textContent = texte;
        }
        requestAnimationFrame(pas);
      });
    });
  }

  /* 03 · Le fil de l’histoire : le défilement fait avancer le temps.
     --present : position du présent (px depuis le haut de la frise), --temps : part vécue (0 → 1).
     Le présent se tient à 70 % de la hauteur de l’écran (75 % sur mobile), avec un lissage d’≈ 0,25 s.
     Chaque chapitre dont le point est dépassé reçoit .is-vecu (et la perd en remontant). */
  function frise(root) {
    O.$$('.hi-frise', root).forEach(function (sec) {
      var corps = O.$('.hi-frise__corps', sec), chaps = O.$$('.hi-chap', sec);
      if (!corps || sec._ok) return; sec._ok = 1;
      sec.classList.add('is-temps');
      var haut = 0, H = 0, points = [], y = -1, raf = 0, visible = false;

      function mesure() {
        var r = corps.getBoundingClientRect();
        haut = r.top + window.scrollY; H = corps.offsetHeight;
        points = chaps.map(function (c) {
          var p = O.$('.hi-chap__point', c).getBoundingClientRect();
          return p.top + p.height / 2 + window.scrollY - haut;
        });
      }
      function maj() {
        raf = 0;
        var repere = window.innerHeight * (O.isMobile() ? 0.75 : 0.7);
        var cible = Math.max(0, Math.min(H, window.scrollY + repere - haut));
        y = y < 0 ? cible : y + (cible - y) * 0.18;
        if (Math.abs(cible - y) < 0.5) y = cible;
        corps.style.setProperty('--present', y.toFixed(1) + 'px');
        corps.style.setProperty('--temps', H ? (y / H).toFixed(4) : 0);
        chaps.forEach(function (c, i) { c.classList.toggle('is-vecu', y >= points[i] - 0.5); });
        if (!sec.classList.contains('is-pret')) requestAnimationFrame(function () { sec.classList.add('is-pret'); }); // pas d’onde au premier affichage
        if (y !== cible) demande();
      }
      function demande() { if (!raf) raf = requestAnimationFrame(maj); }

      mesure(); maj();
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) demande(); }, { rootMargin: '25% 0px 25% 0px' }).observe(corps);
      window.addEventListener('scroll', function () { if (visible) demande(); }, { passive: true });
      window.addEventListener('resize', function () { mesure(); demande(); });
      window.addEventListener('load', function () { mesure(); demande(); });
    });
  }

  function init(root) {
    if (calme()) return;
    ouverture(root); traces(root); compteurs(root); frise(root);
  }

  O.section('histoire', { init: init });
})();
